module.exports = __webpack_public_path__ + "img/sleeve length.a9b1f05d.png";